import request from '@/utils/request';
import Resource from '@/api/resource';
import JSONbig from 'json-bigint';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';

class MediasResource extends Resource {
  constructor() {
    super('medias');
  }

  // 同步媒体账号
  syncMedias() {
    return request({
      url: `/${this.uri}/refreshAllAdvertiserAccessTokenExpire`,
      method: 'get',
    });
  }

  // 筛选媒体账号列表
  getMediasListApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'get',
      params: data,
      transformResponse: (response) => {
        const is_huawei = data?.type === CHANNEL_INTERFACE_TYPE.HUAWEI;
        return is_huawei ? JSONbig({ storeAsString: true }).parse(response) : JSON.parse(response);
      },
    });
  }

  // 添加媒体账号
  addMediasApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'POST',
      data,
    });
  }

  // 更新媒体账号列表
  updateMediasApi(data) {
    return request({
      url: `/${this.uri}/updateNote`,
      method: 'POST',
      data,
    });
  }

  // 更新账户预算
  updateJrttBudgetApi(data) {
    return request({
      url: `/${this.uri}/updateJrttBudget`,
      method: 'POST',
      data,
    });
  }

  // 定时更新预算
  advertiserBudgetTaskApi(data) {
    return request({
      url: `/${this.uri}/jrttBudgetTask`,
      method: 'POST',
      data,
    });
  }

  // 删除定时更新预算
  deleteAdvertiserBudgetTask(data) {
    return request({
      url: `/${this.uri}/deleteJrttBudgetTask`,
      method: 'POST',
      data,
    });
  }

  assignAdvertiserApi(data) {
    return request({
      url: `/${this.uri}/assignAdvertiser`,
      method: 'POST',
      data,
    });
  }

  // 更新备注
  updateNoteApi(data) {
    return request({
      url: `/${this.uri}/updateNote`,
      method: 'POST',
      data,
    });
  }

  // 删除更新账户预算定时任务
  deleteJrttBudgetTaskApi(data) {
    return request({
      url: `/${this.uri}/deleteJrttBudgetTask`,
      method: 'POST',
      data,
    });
  }

  // 更新广告主日预算
  updateGdtBudgetApi(data) {
    return request({
      url: `/${this.uri}/updateGdtBudget`,
      method: 'POST',
      data,
    });
  }

  // 刷新广告主token过期时间
  refreshTokenApi(params) {
    return request({
      url: '/channelInterfaceAuth/refreshAdvertiserAccessTokenExpire',
      method: 'get',
      params,
    });
  }

  // 测试广告主token过期时间
  testTokenApi(params) {
    return request({
      url: '/channelInterfaceAuth/testAdvertiserAccessTokenExpire',
      method: 'get',
      params,
    });
  }

  // 修改广告主返点
  updateAdvertiserRebateApi(data) {
    return request({
      url: '/channelInterfaceAuth/updateAdvertiserRebate',
      method: 'put',
      data,
    });
  }
}

const path = 'medias';

// 筛选媒体账号列表
export function getMediasListApi(data) {
  return request({
    url: `${path}`,
    method: 'get',
    params: data,
    transformResponse: (response) => {
      const is_huawei = data?.type === CHANNEL_INTERFACE_TYPE.HUAWEI;
      return is_huawei ? JSONbig({ storeAsString: true }).parse(response) : JSON.parse(response);
    },
  });
}

export { MediasResource as default };
